export default {
  install(Vue, options) {
    /**
     * Парсит массив для селекта
     * @param arr - массив, который надо распарсить
     * @param val - значение, которое вернется в v-model у селекта
     * @param lab - название значения, которое будет выведено в инпут
     * @returns {*} - вернет объект с двумя полями: label и value
     * @example this.$selectParse(await this.$store.dispatch('fetchAllManufacturers'), 'id', 'name_short')
     */
    Vue.prototype.$selectParse = function(arr, val, lab) {
      return arr.map(el => {
        let value, label
        for (let key in el) {
          if (key === val) {
            value = el[key]
          } else if (key === lab) {
            label = el[key]
          }
        }
        return { value, label }
      })
    }
  },
}
